'use client'

import { SessionProvider } from "next-auth/react"
import type { ComponentProps, ReactNode } from "react"
import { ToastProvider } from "@/contexts/ToastContext"
import { QueryProvider } from "@/components/providers/QueryProvider"
import { SsoAutoLogin } from "@/components/auth/SsoAutoLogin"

export type InitialSession = ComponentProps<typeof SessionProvider>['session']

export function Providers({ children, session }: { children: ReactNode; session?: InitialSession }) {
  return (
    <SessionProvider
      session={session}
      refetchOnWindowFocus={false}
      refetchInterval={0}
    >
      <SsoAutoLogin />
      <QueryProvider>
        <ToastProvider>
          {children}
        </ToastProvider>
      </QueryProvider>
    </SessionProvider>
  )
}
